import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { calculateViewportHeight } from 'b2c-ui/core';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { CommonModule } from '@angular/common';
import { NzDrawerModule, NzButtonModule } from 'ng-zorro-antd';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-mobile-drawer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### [For Mobile Web Usage Only]
 * ##### Import this component individually to your module
 * `import { B2CMobileDrawerModule } from 'b2c-ui/mobile-drawer';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ng-zorro-antd';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'b2c-ui/i18n';

const _c0 = ["drawerContent"];
function B2CMobileDrawerComponent_div_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.actionText);
} }
function B2CMobileDrawerComponent_div_8_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "b2cI18n");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r4.I18nTransKey == null ? null : ctx_r4.I18nTransKey.DONE), " ");
} }
function B2CMobileDrawerComponent_div_8_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileDrawerComponent_div_8_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CMobileDrawerComponent_div_8_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.buttonTemplate);
} }
function B2CMobileDrawerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "button", 7);
    ɵngcc0.ɵɵlistener("click", function B2CMobileDrawerComponent_div_8_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.closeDrawer(); });
    ɵngcc0.ɵɵtemplate(2, B2CMobileDrawerComponent_div_8_ng_container_2_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(3, B2CMobileDrawerComponent_div_8_ng_template_3_Template, 2, 3, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CMobileDrawerComponent_div_8_ng_container_5_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(4);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.actionText)("ngIfElse", _r3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.buttonTemplate);
} }
const _c1 = function () { return { height: "100%" }; };
const _c2 = function (a0) { return { "height": a0 }; };
const _c3 = ["*"];
class B2CMobileDrawerComponent {
    constructor() {
        /**
         * Whether the drawer is visible or not. Double binding.
         */
        this.show = false;
        /**
         * Set the height of the drawer
         */
        this.height = 0;
        /**
         * Set the title of the drawer
         */
        this.title = '';
        /**
         * Hide the button bar
         */
        this.hideButtons = false;
        this.showChange = new EventEmitter();
        /**
         * @ignore
         */
        this.containerHeight = '';
        /**
         * @ignore
         */
        this.I18nTransKey = I18nTransKey;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.height && typeof this.height === 'number') {
            this.containerHeight = `${this.height * 0.7}px`;
            return;
        }
        if (this.height) {
            switch (this.height) {
                case B2CMobileDrawerPresetHeightEnum.HALF:
                    this.height = calculateViewportHeight() * 0.6;
                    this.containerHeight = `${this.height * 0.85}px`;
                    return;
            }
        }
        /** @type {?} */
        const maxHeight = calculateViewportHeight() * 0.8;
        /** @type {?} */
        const maxContainerHeight = `${maxHeight * 0.7}px`;
        // check height of the projected content
        /** @type {?} */
        const height = this.getContentHeight();
        /** @type {?} */
        const minHeight = calculateViewportHeight() * 0.3;
        if (height < maxHeight * 0.7) {
            /** @type {?} */
            const newHeight = height + 150;
            this.height =
                newHeight > maxHeight ? maxHeight : newHeight > minHeight ? newHeight : minHeight;
            this.containerHeight = `${maxHeight * 0.7}px`;
        }
        else {
            this.height = maxHeight;
            this.containerHeight = maxContainerHeight;
        }
    }
    /**
     * @return {?}
     */
    closeDrawer() {
        this.show = false;
        this.showChange.emit(this.show);
    }
    /**
     * @private
     * @return {?}
     */
    getContentHeight() {
        return this.drawerContent.nativeElement.getBoundingClientRect().height;
    }
}
B2CMobileDrawerComponent.ɵfac = function B2CMobileDrawerComponent_Factory(t) { return new (t || B2CMobileDrawerComponent)(); };
B2CMobileDrawerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CMobileDrawerComponent, selectors: [["b2c-mobile-drawer"]], viewQuery: function B2CMobileDrawerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.drawerContent = _t.first);
    } }, inputs: { show: "show", height: "height", title: "title", hideButtons: "hideButtons", actionText: "actionText", buttonTemplate: "buttonTemplate" }, outputs: { showChange: "showChange" }, ngContentSelectors: _c3, decls: 9, vars: 11, consts: [["nzPlacement", "bottom", "nzWrapClassName", "b2c-mobile-drawer", 3, "nzClosable", "nzMaskClosable", "nzHeight", "nzVisible", "nzBodyStyle", "nzOnClose"], [1, "position-absolute", "rounded", "b2c-mobile-drawer-bar"], [1, "w-100", "mb-3", "mt-4", "font-weight-bold", "text-base", "container"], [1, "container", "w-100", "d-block", "overflow-auto", "text-sm", "mb-3", 3, "ngStyle"], ["drawerContent", ""], ["class", "container pt-3 pb-3 b2c-mobile-drawer-action bg-white w-100 d-block fixed-bottom", 4, "ngIf"], [1, "container", "pt-3", "pb-3", "b2c-mobile-drawer-action", "bg-white", "w-100", "d-block", "fixed-bottom"], ["nz-button", "", "nzType", "primary", "nzBlock", "", 3, "click"], [4, "ngIf", "ngIfElse"], ["defaultTemplate", ""], [4, "ngIf"], [4, "ngTemplateOutlet"]], template: function B2CMobileDrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nz-drawer", 0);
        ɵngcc0.ɵɵlistener("nzOnClose", function B2CMobileDrawerComponent_Template_nz_drawer_nzOnClose_0_listener() { return ctx.closeDrawer(); });
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", null, 4);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, B2CMobileDrawerComponent_div_8_Template, 6, 3, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("nzClosable", ctx.hideButtons)("nzMaskClosable", ctx.hideButtons)("nzHeight", ctx.height)("nzVisible", ctx.show)("nzBodyStyle", ɵngcc0.ɵɵpureFunction0(8, _c1));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(9, _c2, ctx.containerHeight));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideButtons);
    } }, directives: [ɵngcc1.NzDrawerComponent, ɵngcc2.NgStyle, ɵngcc2.NgIf, ɵngcc1.NzButtonComponent, ɵngcc2.NgTemplateOutlet], pipes: [ɵngcc3.B2CI18nPipe], encapsulation: 2 });
B2CMobileDrawerComponent.propDecorators = {
    show: [{ type: Input }],
    height: [{ type: Input }],
    title: [{ type: Input }],
    actionText: [{ type: Input }],
    buttonTemplate: [{ type: Input }],
    hideButtons: [{ type: Input }],
    showChange: [{ type: Output }],
    drawerContent: [{ type: ViewChild, args: ['drawerContent', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMobileDrawerComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-mobile-drawer',
                template: "<nz-drawer \r\n [nzClosable]=\"hideButtons\"\r\n [nzMaskClosable]=\"hideButtons\"\r\n (nzOnClose)=\"closeDrawer()\"\r\n nzPlacement=\"bottom\" \r\n [nzHeight]=\"height\" \r\n [nzVisible]=\"show\" \r\n [nzBodyStyle]=\"{height: '100%'}\" \r\n nzWrapClassName=\"b2c-mobile-drawer\">\r\n  <div class=\"position-absolute rounded b2c-mobile-drawer-bar\"></div>\r\n  <div class=\"w-100 mb-3 mt-4 font-weight-bold text-base container\">\r\n    {{ title }}\r\n  </div>\r\n  <div class=\"container w-100 d-block overflow-auto text-sm mb-3\" [ngStyle]=\"{'height': containerHeight}\">\r\n    <div #drawerContent>\r\n      <ng-content></ng-content>\r\n    </div>\r\n  </div>\r\n  <div class=\"container pt-3 pb-3 b2c-mobile-drawer-action bg-white w-100 d-block fixed-bottom\" *ngIf=\"!hideButtons\">\r\n    <button nz-button nzType=\"primary\" nzBlock (click)=\"closeDrawer()\">\r\n      <ng-container *ngIf=\"actionText; else defaultTemplate\">{{ actionText }}</ng-container>\r\n      <ng-template #defaultTemplate>\r\n        {{ I18nTransKey?.DONE | b2cI18n }}\r\n      </ng-template>\r\n    </button>\r\n    <ng-container *ngIf=\"buttonTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"buttonTemplate\"></ng-container>\r\n    </ng-container>\r\n  </div>\r\n</nz-drawer>"
            }]
    }], function () { return []; }, { show: [{
            type: Input
        }], height: [{
            type: Input
        }], title: [{
            type: Input
        }], hideButtons: [{
            type: Input
        }], showChange: [{
            type: Output
        }], actionText: [{
            type: Input
        }], buttonTemplate: [{
            type: Input
        }], drawerContent: [{
            type: ViewChild,
            args: ['drawerContent', { static: false }]
        }] }); })();
if (false) {
    /**
     * Whether the drawer is visible or not. Double binding.
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.show;
    /**
     * Set the height of the drawer
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.height;
    /**
     * Set the title of the drawer
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.title;
    /**
     * Set the text of the actionable button
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.actionText;
    /**
     * Set the action template
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.buttonTemplate;
    /**
     * Hide the button bar
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.hideButtons;
    /** @type {?} */
    B2CMobileDrawerComponent.prototype.showChange;
    /**
     * @ignore
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.drawerContent;
    /**
     * @ignore
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.containerHeight;
    /**
     * @ignore
     * @type {?}
     */
    B2CMobileDrawerComponent.prototype.I18nTransKey;
}
/** @enum {string} */
const B2CMobileDrawerPresetHeightEnum = {
    HALF: "HALF",
    FULL: "FULL",
};

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-mobile-drawer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CMobileDrawerModule {
}
B2CMobileDrawerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CMobileDrawerModule });
B2CMobileDrawerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CMobileDrawerModule_Factory(t) { return new (t || B2CMobileDrawerModule)(); }, imports: [[CommonModule, NzDrawerModule, NzButtonModule, I18nModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CMobileDrawerModule, { declarations: function () { return [B2CMobileDrawerComponent]; }, imports: function () { return [CommonModule, NzDrawerModule, NzButtonModule, I18nModule]; }, exports: function () { return [B2CMobileDrawerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMobileDrawerModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CMobileDrawerComponent],
                exports: [B2CMobileDrawerComponent],
                imports: [CommonModule, NzDrawerModule, NzButtonModule, I18nModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-mobile-drawer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CMobileDrawerComponent, B2CMobileDrawerModule, B2CMobileDrawerPresetHeightEnum };


//# sourceMappingURL=b2c-ui-mobile-drawer.js.map